export const materialSupplier = [
    {
        value: "RINDANG MELATI",
        code: "RITI"
    },
    {
        value: "ALFA JAYA PLYWOOD",
        code: "ALOD"
    },
    {
        value: "RINDANG MELATI UPDATE",
        code: "RITE"
    },
    {
        value: "SUMBER MAS",
        code: "SUAS"
    },
    {
        value: "KURSI MERAH",
        code: "KUAH"
    },
    {
        value: "KURSI MERAH UPDATE",
        code: "KUTE"
    },
    {
        value: "TOKO MAS ABC",
        code: "TOBC"
    },
    {
        value: "ALPHA UTAMA MANDIRI",
        code: "ALRI"
    },
    {
        value: "MITRA SAMUDAYA PERKASA",
        code: "MISA"
    },
    {
        value: "ASIA FALCINDO PRIMA",
        code: "ASMA"
    },
    {
        value: "GOLDEN FOREST",
        code: "GOST"
    },
    {
        value: "METAL MULTI KREASI",
        code: "MESI"
    },
    {
        value: "TK LINGGA",
        code: "TKGA"
    },
    {
        value: "BUANA HPL",
        code: "BUPL"
    },
    {
        value: "SAMA JAYA",
        code: "SAYA"
    },
    {
        value: "MARGA BARATA",
        code: "MATA"
    },
    {
        value: "MARGA BARATA UPDATE",
        code: "MATE"
    },
    {
        value: "MARGA BHARATA UPDATE",
        code: "MATE"
    },
    {
        value: "FRIHEND NUSAINDO JAYA",
        code: "FRYA"
    },
    {
        value: "TOKO SUKSES",
        code: "TOES"
    },
    {
        value: "EUROPA SURYA SENTRA",
        code: "EURA"
    },
    {
        value: "NUANSA NAWA NATMATA",
        code: "NUTA"
    },
    {
        value: "MATT GLOSS MATTER",
        code: "MAER"
    },
    {
        value: "DUTA RAYA",
        code: "DUYA"
    },
    {
        value: "PT BUILDERS SHOP",
        code: "PTOP"
    },
    {
        value: "ELEGANT WOOD INDONESIA",
        code: "ELIA"
    },
    {
        value: "KERTASIVE BANDUNG PJM",
        code: "KEJM"
    },
    {
        value: "REHAU",
        code: "REAU"
    },
    {
        value: "PKDS DUA SAUDARA",
        code: "PKRA"
    },
    {
        value: "SEJATI WOOD & PLYWOOD",
        code: "SEOD"
    },
    {
        value: "POLYCHEMIE ASIA PACIFIC PERMAI",
        code: "POAI"
    },
    {
        value: "LEMINDO",
        code: "LEDO"
    },
    {
        value: "ST GROUP INDONESIA",
        code: "STIA"
    },
    {
        value: "MORE TOOLS",
        code: "MOLS"
    },
    {
        value: "MORE TOOLS UPDATE",
        code: "MOTE"
    },
    {
        value: "MAKMUR JAYA TKI",
        code: "MAKI"
    },
    {
        value: "INDAH JAYA TOOLS",
        code: "INLS"
    },
    {
        value: "BERKAT SEJATI TOKO",
        code: "BEKO"
    },
    {
        value: "MULIA BANGUNAN BANDUNG",
        code: "MUNG"
    },
    {
        value: "TOKO MAKMUR",
        code: "TOUR"
    },
    {
        value: "JAYA ABADII SUKSES",
        code: "JAES"
    },
    {
        value: "PRIMA BANDUNG",
        code: "PRNG"
    },
    {
        value: "MANDIRI PUTRA",
        code: "MARA"
    },
    {
        value: "TOKO PARANTI",
        code: "TOTI"
    },
    {
        value: "CAHAYA MULIA KIMIA",
        code: "CAIA"
    },
    {
        value: "CAHAYA MULIA KIMIA UPDATE",
        code: "CATE"
    },
    {
        value: "TOP SEALANT & TOOLS",
        code: "TOLS"
    },
    {
        value: "TB. INTI JAYA",
        code: "TBYA"
    },
    {
        value: "INTI JAYA",
        code: "INYA"
    },
    {
        value: "CNT TAPE",
        code: "CNPE"
    },
    {
        value: "CNT TAPE UPDATE",
        code: "CNTE"
    },
    {
        value: "ALAKBAN",
        code: "ALAN"
    },
    {
        value: "MERAUKE KOPO",
        code: "MEPO"
    },
    {
        value: "SURGA PERABOT",
        code: "SUOT"
    },
    {
        value: "MITRA PLASTIK",
        code: "MIIK"
    },
    {
        value: "MITRA PLASTIK UPDATE",
        code: "MITE"
    },
    {
        value: "ATK HOUSE",
        code: "ATSE"
    },
    {
        value: "BANCEUY ELEKTRIK",
        code: "BAIK"
    },
    {
        value: "TOKO PELANGI",
        code: "TOGI"
    },
    {
        value: "CEMERLANG TKI",
        code: "CEKI"
    },
    {
        value: "KLOPMART",
        code: "KLRT"
    },
    {
        value: "NIC SANITARY",
        code: "NIRY"
    },
    {
        value: "ALAM JAYA GYPSUM",
        code: "ALUM"
    },
    {
        value: "PRIMA AKSES FITTING",
        code: "PRNG"
    },
    {
        value: "CHANCE FURNITURE FITTINGS",
        code: "CHGS"
    },
    {
        value: "NAGA MAS",
        code: "NAAS"
    },
    {
        value: "KING14",
        code: "KI14"
    },
    {
        value: "OBIG ELECTRONIC",
        code: "OBIC"
    },
    {
        value: "BRACKET OFFCIAL STORE",
        code: "BRRE"
    },
    {
        value: "TOKO PRIMA",
        code: "TOMA"
    },
    {
        value: "JAYA LED GLODOK",
        code: "JAOK"
    },
    {
        value: "GLOTIMA",
        code: "GLMA"
    },
    {
        value: "HOKI JJ STORE",
        code: "HORE"
    },
    {
        value: "SINAR REZEKI 8",
        code: "SI 8"
    },
    {
        value: "REN GOODS",
        code: "REDS"
    },
    {
        value: "VIO KINGDOM",
        code: "VIOM"
    },
    {
        value: "KCP",
        code: "KCCP"
    },
    {
        value: "PINANGSIA",
        code: "PIIA"
    },
    {
        value: "WOODSTOCK FURNITURE DECOR",
        code: "WOOR"
    },
    {
        value: "EVOMAB",
        code: "EVAB"
    },
    {
        value: "VICTORY KERAMIK",
        code: "VIIK"
    },
    {
        value: "CERIA KUNCI",
        code: "CECI"
    },
    {
        value: "VININDO OFFICIAL STORE",
        code: "VIRE"
    },
    {
        value: "MASTER KUNCI",
        code: "MACI"
    },
    {
        value: "TOKO BESI JAYA KUSUMAH",
        code: "TOAH"
    },
    {
        value: "IBAGSTORE",
        code: "IBRE"
    },
    {
        value: "GAN PROPERTI",
        code: "GATI"
    },
    {
        value: "PRIMA BANDUNG UPDATE",
        code: "PRTE"
    },
    {
        value: "PABRIK LISTRIK IND",
        code: "PAND"
    },
    {
        value: "MECHATRONICS STORE",
        code: "MERE"
    },
    {
        value: "ALLADIN SHOP",
        code: "ALOP"
    },
    {
        value: "CAHAYA MUR & BAUT",
        code: "CAUT"
    },
    {
        value: "HASIL FASTINDO",
        code: "HADO"
    },
    {
        value: "HASIL FASTINDO UPDATE",
        code: "HATE"
    },
    {
        value: "ANEKA JASA",
        code: "ANSA"
    },
    {
        value: "BINTANG ABADI MAKMUR",
        code: "BIUR"
    },
    {
        value: "AG MUR DAN BAUT",
        code: "AGUT"
    },
    {
        value: "59 MART",
        code: "59RT"
    },
    {
        value: "HAFELE",
        code: "HALE"
    },
    {
        value: "INARA MART",
        code: "INRT"
    },
    {
        value: "WINSTON OK OFFICIAL STORE",
        code: "WIRE"
    },
    {
        value: "INTERIOR FURNITURE INDONESIA",
        code: "INIA"
    },
    {
        value: "AGUNG SAMPURNA",
        code: "AGNA"
    },
    {
        value: "CEMERLANG",
        code: "CENG"
    },
    {
        value: "TERANG JAYA",
        code: "TEYA"
    },
    {
        value: "MAKITA KABEL",
        code: "MAEL"
    },
    {
        value: "GLODOK123",
        code: "GL23"
    },
    {
        value: "SUMBER REJEKI",
        code: "SUKI"
    },
    {
        value: "DEPO LISTRIK",
        code: "DEIK"
    },
    {
        value: "SINAR TERANG BANDUNG",
        code: "SING"
    },
    {
        value: "IOT OFFICIAL STORE",
        code: "IORE"
    },
    {
        value: "DIMORA LIVING",
        code: "DING"
    },
    {
        value: "BANCEUY ELEKTRIK UP1",
        code: "BAP1"
    },
    {
        value: "ARL INDONESIA",
        code: "ARIA"
    },
    {
        value: "DJP GOOD DAY",
        code: "DJAY"
    },
    {
        value: "D&P ELECTRONICS",
        code: "D&CS"
    },
    {
        value: "JAYA SAKTI",
        code: "JATI"
    },
    {
        value: "GUDANG HID",
        code: "GUID"
    },
    {
        value: "NARDYAH SHOP",
        code: "NAOP"
    },
    {
        value: "MITRA ABADI MERUYA",
        code: "MIYA"
    },
    {
        value: "KURNIA JAYA GM",
        code: "KUGM"
    },
    {
        value: "ALL ABOUT INDSUTRI STORE",
        code: "ALRE"
    },
    {
        value: "UD MUJUR MAKMUR",
        code: "UDUR"
    },
    {
        value: "TUNGGAL JAYA SUNIARAJA",
        code: "TUJA"
    },
    {
        value: "ROLAS",
        code: "ROAS"
    },
    {
        value: "BLUM",
        code: "BLUM"
    },
    {
        value: "TUNGGAL JAYA SUNIARAJA UPDATE",
        code: "TUTE"
    },
    {
        value: "ABADI KLENDER",
        code: "ABER"
    },
    {
        value: "PRIMA",
        code: "PRMA"
    },
    {
        value: "TOKO MAKMUR JAYA",
        code: "TOYA"
    },
    {
        value: "PUSAT AKSESORIS PINTU",
        code: "PUTU"
    },
    {
        value: "PINANGSIAMAS PINANGSIA",
        code: "PIIA"
    },
    {
        value: "NAGA MAS UPDATE",
        code: "NATE"
    },
    {
        value: "GENHARDWARE",
        code: "GERE"
    },
    {
        value: "TOKO TERUS MAJU",
        code: "TOJU"
    },
    {
        value: "AGUNG TUNGGAL JAYA",
        code: "AGYA"
    },
    {
        value: "HAFELE INDOTAMA",
        code: "HAMA"
    },
    {
        value: "TOKO INCOME",
        code: "TOME"
    },
    {
        value: "SKY INDONESIA",
        code: "SKIA"
    },
    {
        value: "INDO FITTING",
        code: "INNG"
    },
    {
        value: "KAGUYA",
        code: "KAYA"
    },
    {
        value: "KNOCKERS",
        code: "KNRS"
    },
    {
        value: "PRIMA SUKSES TOKO",
        code: "PRKO"
    },
    {
        value: "RKG TOOLS",
        code: "RKLS"
    },
    {
        value: "JAYA AGUNG KUNCI SANITARY",
        code: "JARY"
    },
    {
        value: "KRANINDO JAYA JAKARTA",
        code: "KRTA"
    },
    {
        value: "GOLDEN HARDWARE BANDUNG",
        code: "GONG"
    },
    {
        value: "RAFES OFFICIAL",
        code: "RAAL"
    },
    {
        value: "METTA FITTING",
        code: "MENG"
    },
    {
        value: "TOKO BESI KENTJANA",
        code: "TONA"
    },
    {
        value: "REKSA AZIS",
        code: "REIS"
    },
    {
        value: "CAHAYA ABADI",
        code: "CADI"
    },
    {
        value: "DUTA RAYA UPDATE",
        code: "DUTE"
    },
    {
        value: "HAVANA",
        code: "HANA"
    },
    {
        value: "KREASI SENTOSA ABADI",
        code: "KRDI"
    },
    {
        value: "GLORIOUS",
        code: "GLUS"
    },
    {
        value: "PROPAN",
        code: "PRAN"
    },
    {
        value: "QUALI-TECH",
        code: "QUCH"
    },
    {
        value: "GAYA WARNA",
        code: "GANA"
    },
    {
        value: "CASCOW SEJAHTERA CHEMICAL",
        code: "CAAL"
    },
    {
        value: "POLO KIMIA",
        code: "POIA"
    },
    {
        value: "TOKO CAT BUANA",
        code: "TONA"
    },
    {
        value: "WAHANA KARYA TUNGGAL",
        code: "WAAL"
    },
    {
        value: "MAREMA HD",
        code: "MAHD"
    },
    {
        value: "PROPAN UPDATE",
        code: "PRTE"
    },
    {
        value: "PD KHARISMA",
        code: "PDMA"
    },
    {
        value: "SEMESTA SATU",
        code: "SETU"
    },
    {
        value: "TOKO TKI",
        code: "TOKI"
    },
    {
        value: "BORMA TKI",
        code: "BOKI"
    },
    {
        value: "CIBOLERANG",
        code: "CING"
    },
    {
        value: "EKAMANT INDONESIA",
        code: "EKIA"
    },
    {
        value: "TOKO BANGUNAN TKI",
        code: "TOKI"
    },
    {
        value: "EKAMANT INDONESIA UPDATE",
        code: "EKTE"
    },
    {
        value: "INDAH JAYA TEKNIK",
        code: "INIK"
    },
    {
        value: "HOME TOOLS",
        code: "HOLS"
    },
    {
        value: "CAHAYA MUTIARA 2",
        code: "CA 2"
    },
    {
        value: "PANJI SETIA",
        code: "PAIA"
    },
    {
        value: "TOKO HALIM",
        code: "TOIM"
    },
    {
        value: "PANJI PACKING",
        code: "PANG"
    },
    {
        value: "SADANG",
        code: "SANG"
    },
    {
        value: "RAHAYU JAYA",
        code: "RAYA"
    },
    {
        value: "KARYA INDAH",
        code: "KAAH"
    },
    {
        value: "TOKO ENERGIC",
        code: "TOIC"
    },
    {
        value: "STRAMOS",
        code: "STOS"
    },
    {
        value: "INTI MEDIKA STORE",
        code: "INRE"
    },
    {
        value: "BORMA",
        code: "BOMA"
    },
    {
        value: "PAINT COLOUR",
        code: "PAUR"
    },
    {
        value: "TOKO BESI CAHAYA",
        code: "TOYA"
    },
]